// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2GEwB","loaderOuter":"PageOverlayLoader_loaderOuter__7AoP9"};